// ----------------------------------------------------------------------

export const _id = [...Array(20)].map(
  (_, index) => `e99f09a7-dd88-49d5-b1c8-1daf80c2d7b${index + 1}`
);
export const _fullAddress = [
  'Roopena Agrahara, Bommanahalli, Bengaluru, Karnataka 560068',
  'Roopena Agrahara, Bommanahalli, Bengaluru, Karnataka 560068',
  'Roopena Agrahara, Bommanahalli, Bengaluru, Karnataka 560068',
];

// ----------------------------------------------------------------------

export const _booleans = [
  true,
  true,
  true,
  false,
  false,
  true,
  false,
  false,
  false,
  false,
  true,
  true,
  true,
  false,
  false,
  false,
  true,
  false,
  false,
  false,
  true,
  false,
  false,
  true,
];

export const _fullNames = [
  'Arjun Mehta',
  'Nikhil Sharma',
  'Radhika Patel',
  'Sneha Verma',
  'Amit Desai',
  'Rohit Kapoor',
  'Divya Jain',
];

export const _ratings = [
  4.2, 3.7, 4.5, 3.5, 0.5, 3.0, 2.5, 2.8, 4.9, 3.6, 2.5, 1.7, 3.9, 2.8, 4.1, 4.5, 2.2, 3.2, 0.6,
  1.3, 3.8, 3.8, 3.8, 2.0,
];

export const _percents = [
  10.1, 13.6, 28.2, 42.1, 37.2, 18.5, 40.1, 94.8, 91.4, 53.0, 25.4, 62.9, 86.6, 62.4, 35.4, 17.6,
  52.0, 6.8, 95.3, 26.6, 69.9, 92.1, 46.2, 85.6,
];

export const _nativeS = [
  11, 10, 7, 10, 12, 5, 10, 1, 8, 8, 10, 11, 12, 8, 4, 11, 8, 9, 4, 9, 2, 6, 3, 7,
];

export const _nativeM = [
  497, 763, 684, 451, 433, 463, 951, 194, 425, 435, 807, 521, 538, 839, 394, 269, 453, 821, 364,
  849, 804, 776, 263, 239,
];

export const _nativeL = [
  9911, 1947, 9124, 6984, 8488, 2034, 3364, 8401, 8996, 5271, 8478, 1139, 8061, 3035, 6733, 3952,
  2405, 3127, 6843, 4672, 6995, 6053, 5192, 9686,
];

// ----------------------------------------------------------------------

export const _phoneNumbers = ['786-935-1845', '786-935-1845'];

export const _postTitles = [
  'The Evolution of AI: From Automation to Creative Intelligence',
  'Blockchain Beyond Cryptocurrency: Revolutionizing Data Security',
  'Blockchain Beyond Cryptocurrency: Revolutionizing Data Security',
  'Mastering Temporal API in JavaScript Future Proof Date Handling',
];

export const _tags = [
  // Core Technical
  'Technology',
  'Web Development',
  'Frontend Development',
  'Backend Development',
  'Full Stack Development',
  'JavaScript',
  'TypeScript',
  'Python',
  'Java',
  'C#',
  '.NET',
  'PHP',
  'Ruby',

  // Frameworks & Libraries
  'React.js',
  'Angular',
  'Vue.js',
  'Node.js',
  'Django',
  'Flask',
  'Spring Boot',
  '.NET Core',

  // Tools & DevOps
  'Version Control (Git, GitHub)',
  'Docker',
  'Kubernetes',
  'CI/CD Pipelines',
  'Cloud Platforms (AWS, Azure, GCP)',
  'Jenkins',
  'Webpack',

  // Concepts & Practices
  'RESTful APIs',
  'Microservices',
  'Database Design (SQL, NoSQL)',
  'Performance Optimization',
  'Security Best Practices',
  'Testing (Unit, Integration, E2E)',
  'Agile Methodology',
  'Scrum',

  // Emerging Tech
  'AI/ML Engineering',
  'Blockchain',
  'Web3',
  'IoT Development',
  'Serverless Architecture',
  'Cybersecurity',
  'AR/VR Development',

  // Specializations
  'Mobile Development (iOS, Android)',
  'Cross-Platform Development (React Native, Flutter)',
  'Web Accessibility',
  'SEO',

  // Career & Soft Skills
  'Career Growth',
  'Remote Work',
  'Freelancing',
  'Open Source',
  'Tech Industry Trends',
  'Developer Productivity',

  // Motivation & Leadership
  'Motivation',
  'Leadership in Tech',
  'Engineering Management',
  'Team Collaboration',
  'Productivity Tips',
  'Work-Life Balance',
  'Positive Mindset',
];
export const _metaKeywords = [
  // Core Technical
  'Software Development',
  'Modern Web Technologies',
  'Frontend and Backend Skills',
  'Programming Languages',
  'Full Stack Development Techniques',

  // Frameworks & Libraries
  'React vs Angular',
  'Popular JavaScript Frameworks',
  'Frontend Libraries Comparison',
  'Backend Frameworks for Developers',
  'Building Apps with Node and Django',

  // Tools & DevOps
  'DevOps for Developers',
  'CI/CD Best Practices',
  'Docker Kubernetes Guide',
  'Cloud Deployment Strategies',
  'Version Control in Software Teams',

  // Concepts & Practices
  'REST API Design Principles',
  'Scalable Microservice Architecture',
  'SQL vs NoSQL Best Use Cases',
  'Web Performance Tips',
  'Security in Web Applications',
  'Software Testing Techniques',
  'Agile Development Lifecycle',

  // Emerging Tech
  'AI Tools for Developers',
  'Blockchain in Software Development',
  'Web3 Explained for Engineers',
  'IoT Project Ideas for Developers',
  'Serverless Function Use Cases',
  'Cybersecurity Essentials',
  'Developing for AR and VR',

  // Specializations
  'Mobile App Frameworks Comparison',
  'React Native vs Flutter',
  'Web Accessibility Guidelines',
  'Search Engine Optimization for Web Apps',
  'Mobile First Design Strategy',

  // Career & Soft Skills
  'Software Developer Career Path',
  'Remote Developer Productivity',
  'Open Source Contributions Benefits',
  'Freelancing Tips for Developers',
  'Tech Trends to Follow',
  'Boosting Developer Productivity',

  // Motivation & Leadership
  'Staying Motivated in Tech',
  'Becoming a Frontend Tech Lead',
  'Engineering Leadership Qualities',
  'Leading Cross-Functional Teams',
  'Positive Culture in Dev Teams',
  'Work-Life Balance for Developers',
  'Growth Mindset for Engineers',
];

export const _sentences = [
  `What technologies and tools do you specialize in?`,
  `Can you work on both design and development of frontend applications?`,
  `Are you open to freelance, full-time, or remote opportunities?`,
  `How do you ensure performance and accessibility in your projects?`,
  `Can you integrate APIs and work with backend teams?`,
];

// ----------------------------------------------------------------------

export const _descriptions = [
  `I specialize in modern frontend development using React.js, Next.js, TypeScript, JavaScript, and Material UI. I also work with state management libraries like Redux Toolkit and Zustand, and I integrate APIs seamlessly. For deployment and DevOps, I use platforms like Vercel and GitHub Actions. I also have experience integrating Yellow.ai chatbots and using tools like Storybook, Figma, and Postman.`,
  `Yes, I bridge both design and development. I transform UI/UX designs (from tools like Figma or Adobe XD) into responsive, pixel-perfect web interfaces. I focus on accessibility, mobile-first design, and component reusability to ensure both aesthetics and performance.`,
  `I am open to collaborating on freelance, full-time, or remote projects, depending on the opportunity. My goal is to contribute meaningfully to impactful teams or initiatives where I can grow while delivering high-quality frontend solutions.`,
  `I follow best practices such as lazy loading, code splitting, memoization, and Lighthouse audits for performance. For accessibility, I use semantic HTML, ARIA attributes, proper color contrasts, and keyboard navigability to ensure inclusive design.`,
  `Absolutely. I regularly integrate RESTful APIs and have worked with backend technologies via Next.js API routes. I understand how to handle authentication, error handling, and secure data flow, and I collaborate effectively with backend teams to ensure smooth integration and delivery.`,
];

export const _skillscategories = [
  {
    label: 'Web Development',
    icon: '/assets/icons/faqs/ic_website.svg',
    href: '#',
  },
  {
    label: 'App Development',
    icon: '/assets/icons/faqs/ic_app.svg',
    href: '#',
  },

  {
    label: 'TypeScript',
    icon: '/assets/icons/faqs/ic_typescript.svg',
    href: '#',
  },
  {
    label: 'Next JS',
    icon: '/assets/icons/faqs/ic_next.svg',
    href: '#',
  },

  {
    label: 'Node JS',
    icon: '/assets/icons/faqs/ic_node.svg',
    href: '#',
  },
  {
    label: 'Mongo DB',
    icon: '/assets/icons/faqs/ic_mongo.svg',
    href: '#',
  },
  {
    label: 'Nginx',
    icon: '/assets/icons/faqs/ic_nginx.svg',
    href: '#',
  },
  {
    label: 'Code Deployment',
    icon: '/assets/icons/faqs/aws_codedeploy.svg',
    href: '#',
  },
  {
    label: 'SEO',
    icon: '/assets/icons/faqs/ic_seo.svg',
    href: '#',
  },
  {
    label: 'ChatGPT',
    icon: '/assets/icons/faqs/ic_chatgpt.svg',
    href: '#',
  },
  {
    label: 'Problem Solving',
    icon: '/assets/icons/faqs/ic_problem.svg',
    href: '#',
  },

  {
    label: 'System Design',
    icon: '/assets/icons/faqs/ic_system_design.svg',
    href: '#',
  },
];
